module.exports = __webpack_public_path__ + "static/media/best_me_4.22ae4e24.jpg";